<script setup>
import { ref } from 'vue';
import AppLinksSetting from './AppLinksSetting.global.vue';
import GeneralSettings from './GeneralSettings.global.vue';
import ContactsSetting from './ContactsSetting.global.vue';
import RatesSetting from './RatesSetting.global.vue';
import AddressesSetting from './AddressesSetting.global.vue';
import USSDSetting from './USSDSetting.global.vue';
import PaymentProvidersSetting from './PaymentProvidersSetting.global.vue';
import ManualOperationsSetting from './ManualOperationsSetting.global.vue';

const activeTab = ref('links');

const tabs = [
  { id: 'links', label: 'Liens', icon: '🔗' },
  { id: 'general', label: 'Général', icon: '⚙️' },
  { id: 'contacts', label: 'Contacts', icon: '📞' },
  { id: 'rates', label: 'Taux', icon: '💱' },
  { id: 'addresses', label: 'Adresses', icon: '📍' },
  { id: 'paymentProviders', label: 'Providers', icon: '💳' },
  { id: 'manualOperations', label: 'Opérations', icon: '📋' }
  // { id: 'ussd', label: 'USSD', icon: '🔐' }
];
</script>

<template>
  <PageLayout>
    <template #headerTitle>Paramètres de l'application</template>

    <div class="space-y-6">
      <!-- TABS -->
      <div class="flex flex-wrap gap-2 border-b border-gray-200 pb-2">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          @click="activeTab = tab.id"
          :class="[
            'px-6 py-3 rounded-xl font-medium transition-all flex items-center gap-2',
            activeTab === tab.id
              ? 'bg-primary-600 text-white shadow-lg'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          ]"
        >
          <span>{{ tab.icon }}</span>
          <span>{{ tab.label }}</span>
        </button>
      </div>

      <!-- TAB CONTENT -->
      <div class="mt-6">
        <AppLinksSetting v-if="activeTab === 'links'" />
        <GeneralSettings v-else-if="activeTab === 'general'" />
        <ContactsSetting v-else-if="activeTab === 'contacts'" />
        <RatesSetting v-else-if="activeTab === 'rates'" />
        <AddressesSetting v-else-if="activeTab === 'addresses'" />
        <PaymentProvidersSetting v-else-if="activeTab === 'paymentProviders'" />
        <ManualOperationsSetting v-else-if="activeTab === 'manualOperations'" />
        <USSDSetting v-else-if="activeTab === 'ussd'" />
      </div>
    </div>
  </PageLayout>
</template>
